import {
  FormControl as MaterialFormControl,
  RadioGroup as MaterialRadioGroup,
  FormControlLabel as MaterialFormControlLabel,
} from '@material-ui/core';
import styled, { createGlobalStyle, css } from 'styled-components';

import Select from '~/components/Form/Select';
import {
  Content as ModalContent,
  Header as ModalHeader,
  ModalScrollBar,
} from '~/components/Modal/styles';
import {
  HeaderTitle as SidesheetHeader,
  HeaderContainer as SidesheetHeaderContainer,
} from '~/components/Sidesheet/styles';
import colors from '~/styles/colors';
import grid from '~/styles/grid';

export const SidesheetCustomStyle = createGlobalStyle<any>`

  ${SidesheetHeaderContainer} {
    height: 4.5rem;
  }

    ${SidesheetHeader} {
      margin: 1.7rem 1.1rem 0 1.1rem;
     h3 {
       font-size: 32px;
       color: ${colors.lightblack}
     }
    }
`;

export const Container = styled.div``;

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;

  .MuiFormControl-root {
    max-width: 470px;
    width: 100%;
  }
`;

export const FilterWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${grid.sm};
  justify-content: flex-end;
  margin-right: 0.5rem;
  margin-top: -0.8rem;
  height: 3.5rem;
  float: right;
  width: 500px;
`;

export const FilterTitle = styled.p`
  margin: 2.8rem 0 0 0;
  font-size: 14px;
  color: #4d4d4d;
`;

export const SubmitFilterButton = styled.button`
  width: 29.8rem;
  height: 2.8rem;
  border-radius: 5px;
  font-weight: bold;
  border: none;
  background-color: ${colors.primary};
  color: white;
  margin-top: auto;
  align-self: bottom;
`;

export const FilterButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 6.2rem;
  height: 2.8rem;
  color: white;
  border-radius: 5px;
  border: none;
  background: ${colors.primary};
`;

export const FormControl = styled(MaterialFormControl)`
  margin-bottom: 2.4rem !important;
`;

export const RadioGroup = styled(MaterialRadioGroup)``;

export const FormControlLabel = styled(MaterialFormControlLabel)`
  height: 1.5rem;
  border-radius: 11px;
  margin-left: 0px !important;
  padding: 0.2rem 1.1rem;
  font-size: 12px;
  transition: color 0.5s;
  transition: background-color 0.5s;
  transition: ease-in 0.2s;

  ${(props) =>
    props.checked &&
    css`
      background-color: ${colors.primary};
      color: ${colors.white};
    `}

  ${(props) =>
    !props.checked &&
    css`
      color: #4d4d4d;
      background-color: transparent;
      border: 1px solid #eb0045;
    `}


  & span:first-child {
    display: none;
  }
`;

export const RadioContainer = styled.div`
  display: flex;
  gap: 1.4rem;
`;

export const FormControlAssignedOption = styled(MaterialFormControlLabel)`
  display: flex;
  height: 3.2rem;
  width: 14.2rem;
  border-radius: 5px;
  margin-left: 0px !important;
  margin-right: 0px !important;
  justify-content: center;
  font-size: 12px;
  transition: color 0.5s;
  transition: background-color 0.5s;
  transition: ease-in 0.2s;

  ${(props) =>
    props.checked &&
    css`
      backpground-color: rgba(255, 153, 184, 0.25);
      border: 2px solid #eb0045;
      font-weight: bold !important;
      color: #eb0045;

      .MuiTypography-body1 {
        font-weight: bold !important;
      }
    `}

  ${(props) =>
    !props.checked &&
    css`
      background-color: transparent;
      border: 1px solid #b3b3b3;

      color: #4d4d4d;
    `}


  & span:first-child {
    display: none;
  }
`;

export const ContentFooter = styled.div`
  margin-top: 1.4rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const CustomSelect = styled(Select)`
  margin-bottom: 1.4rem;
`;

export const AssingTaskModalContainer = styled.div`
  ${ModalContent} {
    width: 562px;
    height: 320px;
    max-height: 320px;
    padding: 20px 20px 20px 0;
  }

  ${ModalHeader} {
    &::after {
      display: none;
    }
  }

  ${ModalScrollBar} {
    overflow-y: hidden !important;
  }
`;

export const ModalContainer = styled.div`
  margin: 30px 50px;
  height: 320px;
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  height: 40px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  gap: 40px;
  margin-top: 36px;
`;

export const SelectInputContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 20px;
`;
